import { types, getParent } from 'mobx-state-tree';
import _ from 'lodash';
import { filtersByGroupsScheme, getInitialFilterValues } from './utils';
// import Account from '../../models/Account';
import Marketplace from '../../models/MarketPlace';
import { SellerAccountsSelection, StatusSelect, FilterActions } from '../common';
import { statusList, monitoringStatusList } from '../../constants/listings';

const FilterValues = types.compose(
  types
    .model('FilterValues', {
      statuses: types.optional(types.array(types.string), []),
      // this is not selected as a regular filter, it is set in the special account select bar
      // selectedSellerAccounts: types.optional(types.array(types.reference(Account)), []),
      selectedSourceMarketplace: types.maybe(types.reference(Marketplace)),
      timeLeft: types.maybe(types.number),
      outOfStockDays: types.maybe(types.string),
      numberOfOrdersFrom: types.string,
      numberOfOrdersTo: types.string,
      numberOfCompetitorsFrom: types.string,
      numberOfCompetitorsTo: types.string,
      listDateFrom: types.string,
      listDateTo: types.string,
      daysWithoutSale: types.string,
      destinationPriceFrom: types.string,
      destinationPriceTo: types.string,
      sourcePriceFrom: types.string,
      sourcePriceTo: types.string,
      profitFrom: types.string,
      profitTo: types.string,
      profit: types.boolean,
      itemViewsFrom: types.string,
      itemViewsTo: types.string,
      itemWatchersFrom: types.string,
      itemWatchersTo: types.string,
      template: types.string,
      discoveryId: types.string,
      notMonitoring: types.boolean,
      offerType:types.maybe(types.string)
    })
    .views(self => ({
      get templateList() {
        return getParent(self).templateList;
      },
      get templateName() {
        const template = self.templateList.find(t => t.id === self.template) || '';
        return template ? template.name : '';
      },
      get initialFilterValues() {
        return getInitialFilterValues();
      },
      get statusesObj() {
        return _.keyBy(self.statuses, s => s);
      },
      get statusList() {
        return statusList;
      },
      get monitoringStatusList(){
        return monitoringStatusList;
      },
      get scheme() {
        return filtersByGroupsScheme;
      },
      get orderStatusesObj() {
        return _.keyBy(self.statuses, s => s);
      },
      get sources() {
        return getParent(self, 2).settingsStore.markets.sources;
      },
      get sourceName() {
        return self.selectedSourceMarketplace ? self.selectedSourceMarketplace.name : '';
      },
      get sourceId() {
        return self.selectedSourceMarketplace ? self.selectedSourceMarketplace.id : '';
      },
      get offerTypeName(){
        return self.offerType;
      }
    }))
    .actions(self => ({
      setSourceMarketplace(source) {
        self.selectedSourceMarketplace = source;
      },
      setTimeLeft(value) {
        self.timeLeft = value;
      },
      setOutOfStockDays(value) {
        self.outOfStockDays = value;
      },
      setNumberOfOrdersFrom(value) {
        self.numberOfOrdersFrom = value;
      },
      setNumberOfOrdersTo(value) {
        self.numberOfOrdersTo = value;
      },
      setNumberOfCompetitorsFrom(value) {
        self.numberOfCompetitorsFrom = value;
      },
      setNumberOfCompetitorsTo(value) {
        self.numberOfCompetitorsTo = value;
      },
      setListDateFrom(value) {
        self.listDateFrom = value;
      },
      setListDateTo(value) {
        self.listDateTo = value;
      },
      setDaysWithoutSale(value) {
        self.daysWithoutSale = value;
      },
      setDestinationPriceFrom(value) {
        self.destinationPriceFrom = value;
      },
      setDestinationPriceTo(value) {
        self.destinationPriceTo = value;
      },
      setSourcePriceFrom(value) {
        self.sourcePriceFrom = value;
      },
      setSourcePriceTo(value) {
        self.sourcePriceTo = value;
      },
      setProfitFrom(value) {
        console.log('called')
        self.profitFrom = value;
      },
      setProfitTo(value) {
        self.profitTo = value;
      },
      setProfit(value) {
        self.profit = value;
      },
      setItemViewsFrom(value) {
        self.itemViewsFrom = value;
      },
      setItemViewsTo(value) {
        self.itemViewsTo = value;
      },
      setItemWatchersFrom(value) {
        self.itemWatchersFrom = value;
      },
      setItemWatchersTo(value) {
        self.itemWatchersTo = value;
      },
      setTemplate(value) {
        self.template = value;
      },
      setDiscoveryId(value) {
        self.discoveryId = value;
      },
      setNotMonitoring(value) {
        self.notMonitoring = value;
      },
      setOfferType(value){
        self.offerType=value;
      }
    })),
  SellerAccountsSelection,
  StatusSelect,
  FilterActions,
);

export default FilterValues;
